/* src/app/components/notification/notification.component.scss */
.warning-alert:before {
  font-family: upsicons, fantasy !important;
  content: "\e60a" !important;
  font-size: 23px;
  color: #FBD300;
}
.warning-alert {
  margin-right: 13px;
}
.alert-warning {
  display: flex;
  background-color: white;
  color: #242424;
  border-color: #FBD300;
  font-size: 14px;
  min-height: 70px;
  align-items: center;
}
strong {
  margin-right: 0.3em;
}
/*# sourceMappingURL=notification.component.css.map */
